/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityContextDto } from './EntityContextDto';
import {
    EntityContextDtoFromJSON,
    EntityContextDtoFromJSONTyped,
    EntityContextDtoToJSON,
    EntityContextDtoToJSONTyped,
} from './EntityContextDto';

/**
 * 
 * @export
 * @interface CaseEntityDto
 */
export interface CaseEntityDto {
    /**
     * 
     * @type {string}
     * @memberof CaseEntityDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEntityDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEntityDto
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEntityDto
     */
    confidence?: number;
    /**
     * 
     * @type {EntityContextDto}
     * @memberof CaseEntityDto
     */
    context?: EntityContextDto;
    /**
     * 
     * @type {string}
     * @memberof CaseEntityDto
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the CaseEntityDto interface.
 */
export function instanceOfCaseEntityDto(value: object): value is CaseEntityDto {
    return true;
}

export function CaseEntityDtoFromJSON(json: any): CaseEntityDto {
    return CaseEntityDtoFromJSONTyped(json, false);
}

export function CaseEntityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseEntityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'context': json['context'] == null ? undefined : EntityContextDtoFromJSON(json['context']),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function CaseEntityDtoToJSON(json: any): CaseEntityDto {
    return CaseEntityDtoToJSONTyped(json, false);
}

export function CaseEntityDtoToJSONTyped(value?: CaseEntityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'value': value['value'],
        'confidence': value['confidence'],
        'context': EntityContextDtoToJSON(value['context']),
        'tenantId': value['tenantId'],
    };
}

